// Third party
import React from 'react';
import classNames from 'classnames';

// Namespace
import { VALUE_HOME, VALUE_END, VALUE_LEFT, VALUE_RIGHT } from 'keycode-js';

// Utils
import NavigationItem from '@/types/navigation-item';

// Components
import { ControlItem, Tabs } from '@/views/components/navigation';

type TabNavigationProps = {
  sidebarTabs: NavigationItem[];
  selectedSidebarTab: string | undefined;
  onTabChange: (tab: string | undefined) => void;
  className?: string;
};

const TabNavigation = ({ sidebarTabs, selectedSidebarTab, onTabChange, className }: TabNavigationProps) => {
  const tabRefs = React.useRef<Map<string, HTMLButtonElement>>(new Map());

  const onTabKeyDown = (event: React.KeyboardEvent): void => {
    const { key } = event;
    const tabListLength = sidebarTabs.length;
    const currentTabIndex = sidebarTabs.findIndex(tab => tab.id === selectedSidebarTab);
    const acceptedKeys = [VALUE_HOME, VALUE_END, VALUE_LEFT, VALUE_RIGHT];

    if (!acceptedKeys.includes(key)) {
      return;
    }

    let newIndex = 0;

    switch (key) {
      case VALUE_HOME:
        newIndex = 0;
        break;
      case VALUE_END:
        newIndex = tabListLength - 1;
        break;
      case VALUE_LEFT:
        newIndex = (currentTabIndex - 1 + tabListLength) % tabListLength;
        break;
      case VALUE_RIGHT:
        newIndex = (currentTabIndex + 1 + tabListLength) % tabListLength;
        break;
    }

    onTabChange(sidebarTabs?.[newIndex]?.id);
    tabRefs.current.get(sidebarTabs?.[newIndex]?.id ?? '')?.focus();
  };

  return (
    <div className={classNames('tabs-container', className)}>
      <Tabs className="tabs-v2" selected={selectedSidebarTab} onChange={onTabChange} onKeyDown={onTabKeyDown}>
        {sidebarTabs.map(tab => (
          <ControlItem
            id={`proposal-toolbox-${tab.id}-trigger`}
            ref={el => el && tab.id && tabRefs.current.set(tab.id, el)}
            tabIndex={selectedSidebarTab === tab.id ? 0 : -1}
            role="tab"
            aria-selected={selectedSidebarTab === tab.id}
            aria-controls={`proposal-toolbox-${tab.id}-panel`}
            key={tab.id}
            value={tab.id}
          >
            {tab.label}
          </ControlItem>
        ))}
      </Tabs>
    </div>
  );
};

export default TabNavigation;
